import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=22fd18a4&"
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Kentico\\Launchpad.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('22fd18a4', component.options)
    } else {
      api.reload('22fd18a4', component.options)
    }
    module.hot.accept("./pagination.vue?vue&type=template&id=22fd18a4&", function () {
      api.rerender('22fd18a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/custom/vue/custom-apps/components/pagination.vue"
export default component.exports